import { render, staticRenderFns } from "./SearchReportPage.vue?vue&type=template&id=1243376f&"
import script from "./SearchReportPage.vue?vue&type=script&lang=ts&"
export * from "./SearchReportPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports